import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=db6fb8fa&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=ts&"
export * from "./Consent.vue?vue&type=script&lang=ts&"
import style0 from "./Consent.vue?vue&type=style&index=0&id=db6fb8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6fb8fa",
  null
  
)

export default component.exports